module.exports = __webpack_public_path__ + "img/Fixo.74c7b3b7.png";